module.exports = __webpack_public_path__ + "img/building1.7ccb0edc.jpg";